import pic1 from "../../../assistent/Media/moviesland.png";
import pic2 from "../../../assistent/Media/portfolio.png";
import pic3 from "../../../assistent/Media/kasper.png";
import pic4 from "../../../assistent/Media/book.svg";
import pic5 from "../../../assistent/Media/items.svg";
import pic6 from "../../../assistent/Media/resturants.png";
import pic7 from "../../../assistent/Media/university.png";
import pic8 from "../../../assistent/Media/dolla.png";

// eslint-disable-next-line import/no-anonymous-default-export
export default [
  {
    id: 1,
    name: "MoviesLand",
    using: "React",
    githup: "https://github.com/mahmoudashraf74/MoviesLand/tree/master",
    live: "https://mahmoudashraf74.github.io/MoviesLand/",
    pic: pic1,
  },
  {
    id: 2,
    name: "Dolla ",
    using: "React",
    githup: "https://github.com/mahmoudashraf74/dolla_react-app/tree/master",
    live: "https://mahmoudashraf74.github.io/dolla_react-app/",
    pic: pic8,
  },
  {
    id: 3,
    name: "My Portfolio",
    using: "React",
    githup: "https://github.com/mahmoudashraf74/MyPortfolio",
    live: "https://mahmoudashraf74.github.io/MyPortfolio/",
    pic: pic2,
  },
  {
    id: 4,
    name: "Jagerhaus-restaurant",
    using: "React",
    githup:
      "https://github.com/mahmoudashraf74/Jagerhaus-restaurant/tree/master",
    live: "https://mahmoudashraf74.github.io/Jagerhaus-restaurant/",
    pic: pic6,
  },
  {
    id: 5,
    name: "RECIPE BOOK",
    using: "Angular",
    githup: "https://github.com/mahmoudashraf74/Recipe-book-Angular-project-",
    live: "https://github.com/mahmoudashraf74/Recipe-book-Angular-project-",
    pic: pic4,
  },
  {
    id: 6,
    name: "Item Catlog",
    using: "python",
    githup: "https://github.com/mahmoudashraf74/Item-catlog2",
    live: "https://github.com/mahmoudashraf74/Item-catlog2",
    pic: pic5,
  },
  {
    id: 7,
    name: "American-University",
    using: "Html & Css",
    githup: "https://github.com/mahmoudashraf74/MoviesLand.githup.io",
    live: "https://github.com/mahmoudashraf74/MoviesLand.githup.io",
    pic: pic7,
  },
  {
    id: 8,
    name: "Kasper",
    using: "Html & Css",
    githup: "https://github.com/mahmoudashraf74/Kasper.githup.io",
    live: "https://mahmoudashraf74.github.io/Kasper.githup.io/",
    pic: pic3,
  },
];
